import React, { useState } from "react";
import Content from '../../components/Content';
import "./UtilizationDashboardScreen.css";
import { BarChart, Bar, XAxis, YAxis, Tooltip, LineChart, Line, Legend, CartesianGrid, ResponsiveContainer } from "recharts";
import CustomChartCard from "../../components/CustomChartCard";
import FilterUtilization from "./FilterUtilization";
import { useDispatch, useSelector } from "react-redux";
import { getAllClinicsAction } from "../../redux/actions/clinicActions";
import { logout } from "../../redux/actions/userActions";
import { GetUtilizationDataAction } from "../../redux/actions/adminActions";

const UtilizationDashboardScreen = ({ history }) => {
  const dispatch = useDispatch();
  const [showFilter, setShowFilter] = useState(true);
  const [selectedClinic, setSelectedClinic] = React.useState({ value: [], error: '' });
  const [clinicData, setClinicData] = React.useState([]);
  const userLogin = useSelector((state) => state.userLogin);
  const allClinics = useSelector((state) => state.allClinics);
  const GetUtilizationReport = useSelector((state) => state.GetUtilizationReport);
  const [assessments, setAssessments] = React.useState([]);
  const [risk, setRisk] = React.useState([]);
  const [registrationData, setRegistrationData] = React.useState([]);
  const [painLocation, setPainLocation] = React.useState([]);
  const [deviceData, setDeviceData] = React.useState([]);
  const [apiCallData, setApiCallData] = React.useState([]);



  React.useEffect(() => {
    if (userLogin && userLogin.userInfo && !userLogin.userInfo.token) {
      dispatch(logout());
      history.push("/login");
    } else if (!localStorage.getItem("userInfo")) {
      dispatch(logout());
      history.push("/login");
    } else if (
      userLogin &&
      userLogin.userInfo &&
      userLogin.userInfo.issuccess &&
      (userLogin.userInfo.issuperadmin || userLogin.userInfo.isgroupadmin || userLogin.userInfo.isclinicadmin)
    ) {
      dispatch(getAllClinicsAction());
      dispatch(GetUtilizationDataAction({ "clinicId": [] }));
    }
  }, [userLogin, history, dispatch]);

  React.useEffect(() => {
    if (GetUtilizationReport && GetUtilizationReport.data && GetUtilizationReport.data.status) {

      // Call function
      const chartData = getMonthWiseData(GetUtilizationReport.data.utilizationData);
      const chartRegisterData = getMonthWiseRegisterData(GetUtilizationReport.data.registerData);
      const chartPainData = getPainLocationData(GetUtilizationReport.data.painLocationData);


      const assessData = [];
      const riskData = [];
      const registerDataTmp = [];

      chartData.forEach(element => {
        assessData.push({
          name: element.month,
          value: element.totCompleted
        })

        riskData.push({
          name: element.month,
          high: element.highRisk,
          moderate: element.modRisk,
          low: element.lowRisk
        })
      });

      chartRegisterData.forEach(element => {
        registerDataTmp.push({
          name: element.month,
          value: element.totalRegister
        })
      });

      setAssessments(assessData);
      setRisk(riskData);
      setRegistrationData(registerDataTmp);

      const PainDataTmp = convertToChartData(chartPainData);

      setPainLocation(PainDataTmp);

      if (userLogin?.userInfo.issuperadmin) {
        const deviceData = getDeviceData(GetUtilizationReport.data.deviceChartData);
        const apiCallData = getApiCallData(GetUtilizationReport.data.apiCallLogsData);
        setDeviceData(convertToDeviceChartData(deviceData));
        setApiCallData(convertToApiCallData(apiCallData));
      }
    }
  }, [GetUtilizationReport]);



  const getMonthWiseData = (data) => {
    const result = {};

    data.forEach(item => {
      const month = item.monthName; // Grouping by monthName

      if (!result[month]) {
        result[month] = {
          month,
          highRisk: 0,
          modRisk: 0,
          lowRisk: 0,
          totCompleted: 0,
          totCreated: 0
        };
      }

      result[month].highRisk += item.highRisk;
      result[month].modRisk += item.modRisk;
      result[month].lowRisk += item.lowRisk;
      result[month].totCompleted += item.totCompleted;
      result[month].totCreated += item.totCreated;
    });

    return Object.values(result);
  }

  const getMonthWiseRegisterData = (data) => {
    const result = {};

    data.forEach(item => {
      const month = item.monthName; // Grouping by monthName

      if (!result[month]) {
        result[month] = {
          month,
          totalRegister: 0
        };
      }

      result[month].totalRegister += item.totalRegister;
    });

    return Object.values(result);
  }

  const getPainLocationData = (data) => {
    const result = {};

    data.forEach(item => {
      const { displayText, monthName, totalPatient } = item;

      if (!result[displayText]) {
        result[displayText] = {
          displayText,
          months: {},
          totalPatient: 0
        };
      }

      // Add month-wise total
      if (!result[displayText].months[monthName]) {
        result[displayText].months[monthName] = 0;
      }

      result[displayText].months[monthName] += totalPatient;

      // Add overall total
      result[displayText].totalPatient += totalPatient;
    });

    return Object.values(result);
  };


  const getApiCallData = (data) => {
    const result = {};

    data.forEach(item => {
      const { name, monthName, totalCalls } = item;

      if (!result[name]) {
        result[name] = {
          name,
          months: {},
          totalCalls: 0
        };
      }

      // Add month-wise total
      if (!result[name].months[monthName]) {
        result[name].months[monthName] = 0;
      }

      result[name].months[monthName] += totalCalls;
      // Add overall total
      result[name].totalCalls += totalCalls;
    });

    return Object.values(result);
  };

  const getDeviceData = (data) => {
    const result = {};

    data.forEach(item => {
      const { deviceType, monthName, totCreated } = item;

      if (!result[deviceType]) {
        result[deviceType] = {
          deviceType,
          months: {},
          totCreated: 0
        };
      }

      // Add month-wise total
      if (!result[deviceType].months[monthName]) {
        result[deviceType].months[monthName] = 0;
      }

      result[deviceType].months[monthName] += totCreated;
      // Add overall total
      result[deviceType].totCreated += totCreated;
    });

    return Object.values(result);
  };

  const getLast12MonthMap = () => {
    const months = ["Jan", "Feb", "Mar", "Apr", "May", "Jun",
      "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

    const map = {};
    const today = new Date();

    for (let i = 0; i < 12; i++) {
      const d = new Date(today.getFullYear(), today.getMonth() - i, 1);
      const shortYear = String(d.getFullYear()).slice(-2); // "25"

      const label = `${months[d.getMonth()]} ${shortYear}`;
      map[label] = label;   // key = "Jan 2025", value = "Jan 2025"
    }

    return map;
  }

  const monthMap = getLast12MonthMap();


  const convertToChartData = (groupedData) => {
    const chartData = {};

    groupedData.forEach(item => {
      Object.keys(item.months).forEach(monthName => {
        const shortName = monthMap[monthName];

        if (!chartData[shortName]) {
          chartData[shortName] = { name: shortName };
        }

        chartData[shortName][item.displayText] = item.months[monthName];
      });
    });

    return Object.values(chartData);
  };




  const convertToApiCallData = (groupedData) => {
    const chartData = {};

    groupedData.forEach(item => {
      Object.keys(item.months).forEach(monthName => {
        const shortName = monthMap[monthName];

        if (!chartData[shortName]) {
          chartData[shortName] = { name: shortName };
        }

        chartData[shortName][item.name] = item.months[monthName];
      });
    });

    return Object.values(chartData);
  };

  const convertToDeviceChartData = (groupedData) => {
    const chartData = {};

    groupedData.forEach(item => {
      Object.keys(item.months).forEach(monthName => {
        const shortName = monthMap[monthName];

        if (!chartData[shortName]) {
          chartData[shortName] = { name: shortName };
        }

        chartData[shortName][item.deviceType] = item.months[monthName];
      });
    });

    return Object.values(chartData);
  };

  const handleClear = () => {
    setSelectedClinic({ value: [], error: '' });
    dispatch(GetUtilizationDataAction({ "clinicId": [] }));
  };

  const handleFilterSubmit = () => {
    var res = selectedClinic.value.map(s => s.id);
    console.log(selectedClinic, 'selectedClinic', res);
    dispatch(GetUtilizationDataAction({
      "clinicId": res
    }));
  };

  React.useEffect(() => {
    if (allClinics && allClinics.data && allClinics.data.length > 0) {
      const clinicList = buildClinicsList(allClinics.data); //
      setClinicData(clinicList);
    }
  }, [allClinics]);


  const buildClinicsList = (Clinics) => {
    let clinic = [{
      id: '0',
      value: 'all',
      label: 'Select Clinic',
    }];

    Clinics
      .sort((a, b) => {
        const nameA = a.name;
        const nameB = b.name;
        return nameA.localeCompare(nameB);
      })
      .forEach(item => {
        clinic.push({
          id: item.clinicId,
          value: item.clinicId,
          label: item.name
        });
      });

    return clinic;
  };

  const getTopFiveKeys = (data) => {
    const totals = {};

    data.forEach(row => {
      Object.keys(row).forEach(key => {
        if (key !== "name") {
          totals[key] = (totals[key] || 0) + (row[key] || 0);
        }
      });
    });

    return Object.entries(totals)
      .sort((a, b) => b[1] - a[1]) // highest first
      .slice(0, 5)                 // top 5
      .map(item => item[0]);       // return only keys
  };

  const getRandomColor = () => "#" + Math.floor(Math.random() * 16777215).toString(16); 
  
  return (
    <Content current="Utilization Dashboard" headerTitle="Utilization Dashboard" currentMenu="Utilization Dashboard">
      {!userLogin?.userInfo.isclinicadmin && (
        <FilterUtilization
          data={{
            showFilter,
            setShowFilter,
            allClinics,
            handleFilterSubmit,
            handleClear,
            clinicData,
            setClinicData,
            selectedClinic,
            setSelectedClinic
          }}
        />
      )}

      <div className="utilization-container">
        <div className="grid-container">
          {/* registrations */}
          <CustomChartCard title="No. of registrations by month" >
            {GetUtilizationReport.loading ? (
              <div className="chart-skeleton"></div>
            ) : (
              <ResponsiveContainer width="100%" height={260}>
                <BarChart data={registrationData} barCategoryGap="20%">
                  <defs>
                    <linearGradient id="gradientBlue" x1="0" y1="0" x2="0" y2="1">
                      <stop offset="0%" stopColor="#38BDF8" />      {/* Light blue */}
                      <stop offset="100%" stopColor="#1E3A8A" />    {/* Dark blue */}
                    </linearGradient>
                  </defs>

                  <CartesianGrid strokeDasharray="3 3" opacity={0.3} />
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />

                  <Bar
                    dataKey="value"
                    fill="url(#gradientBlue)"
                    radius={[10, 10, 0, 0]}   // rounded top corners
                  />
                </BarChart>
              </ResponsiveContainer>
            )}
          </CustomChartCard>

          {/* Assessments */}
          <CustomChartCard title="Count of completed assessments by month" >
            {GetUtilizationReport.loading ? (
              <div className="chart-skeleton"></div>
            ) : (
              <ResponsiveContainer width="100%" height={260}>
                <LineChart width={450} height={250} data={assessments}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Line type="monotone" dataKey="value" radius={[8, 8, 0, 0]} fill="#444343ff" />
                </LineChart>
              </ResponsiveContainer>
            )}
          </CustomChartCard>
        </div>
        <div className="grid-container">
          {/* Pain Location */}
          <CustomChartCard title="Top 5 Pain location count by month" >
            {GetUtilizationReport.loading ? (
              <div className="chart-skeleton"></div>
            ) : (
              <ResponsiveContainer width="100%" height={260}>
                <LineChart width={900} height={300} data={painLocation}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <CartesianGrid strokeDasharray="3 3" />

                  {getTopFiveKeys(painLocation).map((key, index) => (
                    <Line
                      key={key}
                      type="monotone"
                      dataKey={key}
                      stroke={getRandomColor()}
                      strokeWidth={2}
                    />
                  ))}
                </LineChart>
              </ResponsiveContainer>
            )}
          </CustomChartCard>
          {/* Risk Rating */}
          <CustomChartCard title="Risk rating count by month" >
            {GetUtilizationReport.loading ? (
              <div className="chart-skeleton"></div>
            ) : (
              <ResponsiveContainer width="100%" height={260}>
                <BarChart width={450} height={250} data={risk}>
                  <XAxis dataKey="name" />
                  <YAxis />
                  <Tooltip />
                  <Legend />
                  <Bar dataKey="high" stackId="a" fill="#D32F2F" />
                  <Bar dataKey="moderate" stackId="a" fill="#ED6C02" />
                  <Bar dataKey="low" stackId="a" fill="#2E7D32" />
                </BarChart>
              </ResponsiveContainer>
            )}
          </CustomChartCard>

          {userLogin?.userInfo.issuperadmin &&
            <>
              {/* Device Type */}
              <CustomChartCard title="Assessment completed device type by month" >
                {GetUtilizationReport.loading ? (
                  <div className="chart-skeleton"></div>
                ) : (
                  <ResponsiveContainer width="100%" height={260}>
                    <LineChart width={900} height={300} data={deviceData}>
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <CartesianGrid strokeDasharray="3 3" />

                      {getTopFiveKeys(deviceData).map((key, index) => (
                        <Line
                          key={key}
                          type="monotone"
                          dataKey={key}
                          stroke={getRandomColor()}
                          strokeWidth={2}
                        />
                      ))}
                    </LineChart>
                  </ResponsiveContainer>
                )}
              </CustomChartCard>

              {/* API Audit logs */}
              <CustomChartCard title="EHR API call log by month" >
                {GetUtilizationReport.loading ? (
                  <div className="chart-skeleton"></div>
                ) : (
                  <ResponsiveContainer width="100%" height={260}>
                    <LineChart width={900} height={300} data={apiCallData}>
                      <XAxis dataKey="name" />
                      <YAxis />
                      <Tooltip />
                      <Legend />
                      <CartesianGrid strokeDasharray="3 3" />

                      {getTopFiveKeys(apiCallData).map((key, index) => (
                        <Line
                          key={key}
                          type="monotone"
                          dataKey={key}
                          stroke={getRandomColor()}
                          strokeWidth={2}
                        />
                      ))}
                    </LineChart>
                  </ResponsiveContainer>
                )}
              </CustomChartCard>
            </>
          }
        </div>
      </div>
    </Content>
  );
}

export default UtilizationDashboardScreen;

